export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/LP_04-658637f111014602b47144673680a4ee.jpg";